<template>
  <div>
    <!-- <p class="c-inner-title">用户分组</p> -->
    <div class="auto">
      <page-title title="用户分组" icon="fa-wechat"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" @click="handleAdd" size="small"> 新增分组任务</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              &nbsp;
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            style="width: 100%" v-loading="loading" size="small">
            <el-table-column width="160" prop="group_name" label="分组名称"></el-table-column>
            <el-table-column prop="group_id" label="分组id"></el-table-column>
            <el-table-column prop="estimate_count" label="预计分组人数"></el-table-column>
            <el-table-column prop="count" label="实际分组人数"></el-table-column>
            <el-table-column width="200" prop="package_id" label="人群包">
              <template slot-scope="scope">
                <ul>
                  <li v-for="(item, index) in scope.row.package_info" :key="index">{{item.name}}（{{item.total}}人）</li>
                </ul>
              </template>
            </el-table-column>
            <el-table-column prop="status_name" label="状态"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
          </el-table>
          <div v-if="listcount > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="listcount">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="新增分组任务" :modal-append-to-body="false" :close-on-click-modal="false" width="940px" :visible.sync="dialogVisible" @close="handleExit" class="phone-d">
      <el-form :model="form" :rules="rules" ref="refForm" label-width="100px" size="small">
        <el-form-item label="人群包：" prop="package_id" class="custom-transfer">
          <el-transfer
            filterable
            :titles="['可选项', '已选项']"
            filter-placeholder="请输入关键字搜索"
            v-model="form.package_id"
            :data="packageList">
          </el-transfer>
        </el-form-item>
        <el-form-item label="选择分组：" prop="group_id">
          <el-select v-model="form.group_id" placeholder="请选择">
            <el-option
              v-for="item in groupOptions"
              :key="item.group_id"
              :label="item.name"
              :value="item.group_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-button type="primary" @click="handleSubmit">确定</el-button>
          <el-button @click="handleExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie'
import { Mp } from '@/model'
export default {
  data () {
    return {
      dialogVisible: false,
      tableData: [],
      loading: false,
      dialogLoading: false,
      groupOptions: [],
      form: {
        group_id: '',
        package_id: []
      },
      rules: {
        group_id: [
          { required: true, message: '请选择分组', trigger: 'blur' }
        ],
        package_id: [
          { type: 'array', required: true, message: '请选择人群包', trigger: 'change' }
        ]
      },
      filter: {
        page: '1',
        limit: '10'
      },
      listcount: 0,
      packageList: []
    }
  },
  watch: {
    '$route': function (val) {
      this.queryToFilter()
    },
    'form.package_id': function (newval, oldval) {
      if (newval.length > 5) {
        this.$message.error('最多只能选5个人群包!')
        this.form.package_id = oldval
      }
    }
  },
  methods: {
    resetFilter () {
      this.filter = {
        page: '1',
        limit: '10'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/mp/group/user', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    async getList (param = {}) {
      this.loading = true
      let result = await Mp.UserGroup.getGroupAllotTask(this.filter)
      this.tableData = result['data']['list']
      this.listcount = result['data']['total']
      this.loading = false
    },
    async getGroupList (param = {}) {
      let resultGroup = await Mp.UserGroup.list(param)
      this.groupOptions = resultGroup['data']['list']
    },
    handleAdd (row) {
      this.dialogVisible = true
    },
    handleSubmit () {
      this.$refs['refForm'].validate(async (valid) => {
        if (valid) {
          this.dialogLoading = true
          let result = await Mp.UserGroup.saveGroupAllotTask({
            package_id: this.form.package_id,
            group_id: this.form.group_id
          })
          if (result && !result['err_code']) {
            this.resetFilter()
            this.getList()
            this.handleExit()
          } else {
            this.$message.error(result['err_msg'])
          }
          this.dialogLoading = false
        } else {
          return false
        }
      })
    },
    handleExit () {
      this.dialogVisible = false
      this.form = {
        group_id: '',
        package_id: []
      }
    },
    async getFilterPackageList () {
      let res = await Mp.System.getFilterPackageList()
      if (!res['err_code']) {
        let options = []
        res['data'].map(item => {
          options.push({
            label: item.name + '（' + item.total + '人）',
            key: item.id
          })
        })
        this.packageList = options
      }
    }
  },
  created () {
    this.queryToFilter()
    this.getFilterPackageList()
    this.getGroupList()
  }
}
</script>

<style scoped>
.filterTitle {
  padding-top: 8px;
}
.filterBox {
  margin-top: 15px;
}
.colStyle {
  font-size: 12px;
  line-height: 40px;
  color: #4a4a4a;
  text-indent: 5px;
}
.colTitle {
  color: #4a4a4a;
}
</style>
